import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChatUser } from 'src/app/models/chatBox.model';
import { ArtistProductsSummaryRequest } from 'src/app/Services/artistproducts.service';
import { Artist } from 'src/app/Services/artists.service';
import { ApplicationUser, AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { ConnectionsService } from 'src/app/Services/connections.service';
import { ShareService } from 'src/app/Services/shared/share.service';

export interface MenuGalleryItem {
    id: string;
    label: string;
}

@Component({
    selector: 'app-gallery-onboarding-checklist',
    templateUrl: './gallery-onboarding-checklist.component.html',
    styleUrls: ['./gallery-onboarding-checklist.component.css'],
    standalone: false
})
export class GalleryOnboardingChecklistComponent implements OnInit {
    public currentIndex = 0;
    public completedSteps: string[] = [];
    public updatedUser!: ApplicationUser;
    public connectedArtist: Artist[] = [];
    public authConfig: AuthConfig = {};
    public galleryId!: string;

    gallerymenuList: MenuGalleryItem[] = [
        { id: 'welcomeToArtFlowPro', label: 'Welcome to ArtFlow Pro' },
        { id: 'addDetails', label: 'Add your details' },
        { id: 'demonstrationGallery', label: 'Look at a demonstration gallery site' },
        { id: 'connectArtists', label: 'Connect to some of your artists' },
        { id: 'socialMedia', label: 'Social media' },
        { id: 'artFlowMobileApp', label: 'The ArtFlow Mobile app' },
        { id: 'videoTutorials', label: 'Demonstrations and video tutorials' },
        { id: 'contactUs', label: 'Contact us' }
    ];

    constructor(
        private router: Router,
        private shareService: ShareService,
        private ngxSpinnerService: NgxSpinnerService,
        private connectionsService: ConnectionsService,
        private authService: AuthService
    ) { }

    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authService.isGallery()) {
            this.galleryId = this.authService.getUserId();
            // this.getConnectedArtists(this.galleryId);
        }
        this.shareService.updateVisibility(false);
    
        const savedCompletedSteps = localStorage.getItem('completedSteps');
        this.completedSteps = savedCompletedSteps ? JSON.parse(savedCompletedSteps) : [];
    
        const savedRoute = localStorage.getItem('currentRoute');
        
        if (savedRoute) {
            // Find the index of the saved route
            const savedIndex = this.gallerymenuList.findIndex(item => item.id === savedRoute);
            if (savedIndex !== -1) {
                this.currentIndex = savedIndex;
            } else {
                this.currentIndex = 0; // Fallback to the first item if the route is not found
            }
        } else {
            this.currentIndex = 0; // Default to the first item if nothing is saved
        }
    
        // Navigate to the current route
        this.navigateTo(this.gallerymenuList[this.currentIndex].id);
    }
    
    
    ngOnDestroy(): void {
        this.shareService.updateVisibility(true);
    }
    
    updateActiveClass(): void {
        this.gallerymenuList.forEach((item, index) => {
            const element = document.getElementById(item.id);
            if (element) {
                element.classList.remove('active');
                element.classList.remove('completed');
                if (index === this.currentIndex) {
                    element.classList.add('active');
                }
                if (this.completedSteps.includes(item.id)) {
                    element.classList.add('completed');
                }
            }
        });
    }
    
    advance(): void {
        const currentItem = this.gallerymenuList[this.currentIndex].id;
        if (!this.completedSteps.includes(currentItem)) {
            this.completedSteps.push(currentItem);
            localStorage.setItem('completedSteps', JSON.stringify([...new Set(this.completedSteps)]));
        }
    
        if (this.currentIndex < this.gallerymenuList.length - 1) {
            this.currentIndex++;
            this.navigateTo(this.gallerymenuList[this.currentIndex].id);
        } else {
            console.log('All steps complete');
        }
    }
    
    navigateTo(route: string): void {
        this.currentIndex = this.gallerymenuList.findIndex(item => item.id === route);
        this.updateActiveClass();
    }
    
    public saveAndAdvance(): void {
        const currentItem = this.gallerymenuList[this.currentIndex].id;
        if (!this.completedSteps.includes(currentItem)) {
            this.completedSteps.push(currentItem);
            localStorage.setItem('completedSteps', JSON.stringify([...new Set(this.completedSteps)]));
        }
    
        switch (currentItem) {
            case 'welcomeToArtFlowPro':
                break;
            case 'addDetails':
                this.SaveUpdatedUser(this.updatedUser);
                break;
            case 'demonstrationGallery':
                break;
            case 'connectArtists':
                break;
            case 'socialMedia':
                break;
            case 'artFlowMobileApp':
                break;
            case 'videoTutorials':
                break;
            case 'contactUs':
                break;
            default:
                break;
        }
    
        localStorage.setItem('currentRoute', currentItem);
        this.advance();
    }
    
    isItemClickable(index: number): boolean {
        return true;
    }
    

    // private getConnectedArtists(galleryId: string | null = null, filters: ArtistProductsSummaryRequest = {}) {
    //     this.ngxSpinnerService.show();
    //     this.connectionsService.getConnectedArtists(galleryId, true, filters).subscribe((data: Artist[]) => {
    //         this.connectedArtist = data;
    //         console.log('connectedArtist', this.connectedArtist);
    //         this.ngxSpinnerService.hide();
    //     }, (error) => {
    //         console.error('Error fetching connected Artist:', error);
    //         this.ngxSpinnerService.hide();
    //     });
    // }

    // public navigateToViewArtist(rowData: Artist) {
    //     if (!this.authConfig.IsGalleryStaff) {
    //         if (rowData.IsInviteAccepted) {
    //             this.router.navigate(['/artist', rowData.Id]);
    //         } else if (rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted) {
    //             this.router.navigate(['/connection-request', rowData.ConnectionId]);
    //         } else {
    //             this.router.navigate(['/view-artist-profile', rowData.Id]);
    //         }
    //     }
    // }

    // public goToConnectionRequestDetail(rowData: Artist) {
    //     this.router.navigate(['/connection-request', rowData.ConnectionId]);
    // }

    // public ChatwithArtist(user: ChatUser) {
    //     this.router.navigate(['/inbox', user.Id]);
    // }

    SaveUpdatedUser(updatedUser: any) {
        console.log('User data saved:', updatedUser);
        this.updatedUser = updatedUser; // Save the updated user data
        this.advance();
    }

}
